<template>
    <div>
        <template v-for="(language, key) in $language.available">
            <a :key="key" v-if="$language.current != key" href="#" @click="languageSwitch(key)">
                <svg-vue icon="earth-home-world" class="icon"/> {{ key }}
            </a>
        </template>
    </div>

</template>

<script>
export default {
    methods: {
        languageSwitch(key) {
            this.$language.current = key;
            window._locale = key;

            this.$inertia.post(this.$$route('language', {'language': key}), {
                _token: this.$page.props.csrf_token,
            }, {
                onSuccess: () => {
                    location.reload();
                },
            });

        }
    }
};
</script>
